import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b40a9c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section-values mt-0.5 ml-2.5 flex flex-col gap-0.5"
}

import { PropType } from 'vue';
import { BlackDesertItemTooltipSection } from '@blackdesertmarket/interfaces';
import { VueAttributeClass } from '@/types/attributes-vue';
import { FormatNameFunction, FormatValueFunction } from '@/composables/item-tooltip/use-item-tooltip';
import {
  UseItemTooltipSectionReturn,
  useItemTooltipSection,
} from '@/composables/item-tooltip/use-item-tooltip-section';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemTooltipSection',
  props: {
  itemTooltipSection: {
    type: Object as PropType<BlackDesertItemTooltipSection>,
    required: true,
  },
  formatName: {
    type: Function as PropType<FormatNameFunction>,
  },
  formatValue: {
    type: Function as PropType<FormatValueFunction>,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
  nameClass: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
  valueClass: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
},
  setup(__props) {

const props = __props;



const itemTooltipSectionComposable: UseItemTooltipSectionReturn = useItemTooltipSection(props.itemTooltipSection);

const getItemTooltipSectionName = (): string => {
  if (!props.formatName) {
    return itemTooltipSectionComposable.getSectionName();
  }

  return props.formatName(itemTooltipSectionComposable.getSectionName());
};

const getItemTooltipSectionValue = (value: string): string => {
  if (!props.formatValue) {
    return value;
  }

  return props.formatValue(value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([props.class, "flex flex-col rounded p-1.5 text-xs text-dark-900"])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass([props.nameClass, "section-name"])
    }, _toDisplayString(getItemTooltipSectionName()), 3),
    (props.itemTooltipSection.values)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.itemTooltipSection.values, (value) => {
            return (_openBlock(), _createElementBlock("span", {
              key: value,
              class: _normalizeClass(props.valueClass)
            }, _toDisplayString(getItemTooltipSectionValue(value)), 3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})